import I18n from 'i18n-js';
import React from 'react';

import { mapFavoriteToEntityType } from '@reverbdotcom/commons/src/favorites/entity_type';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { FavoriteButton } from './favorite_button';
import { ExternalProps, useFindFavorite } from './find_favorite_context';
import { LoggedOutFavoriteButton } from './logged_out_favorite_button';

const COMPONENT_NAME = 'FavoriteButton (Banner)';
interface FavoriteButtonBannerProps {
  filtersApplied?: boolean;
}

export function FavoriteButtonBanner(props: ExternalProps & FavoriteButtonBannerProps) {
  const {
    favorite,
    canFavorite,
  } = useFindFavorite();
  const user = useUser();
  
  let bannerHeaderContent;
  if (props.header) {
    bannerHeaderContent = props.header;
  } else if (favorite.favorited) {
    bannerHeaderContent = I18n.t(`discovery.favorites.banner.saved.${mapFavoriteToEntityType(favorite)}`);
  } else {
    bannerHeaderContent = I18n.t('discovery.favorites.banner.notSaved.title');
  }

  let bannerSubtextContent;
  if (props.subtext) {
    bannerSubtextContent = props.subtext;
  } else if (favorite.favorited) {
    bannerSubtextContent = I18n.t('discovery.favorites.banner.saved.body');
  } else if (props.filtersApplied) {
    bannerSubtextContent = I18n.t('discovery.favorites.banner.notSaved.body.filtered');
  } else {
    bannerSubtextContent = I18n.t('discovery.favorites.banner.notSaved.body.unfiltered');
  }

  if (!canFavorite) return null;

  return (
    <div className="favorite-button" >
      <div className="feed-button__banner" data-testid="favorite-banner">
        <h4 className="size-150 mobile-size-130 weight-bold pb-1">
          {bannerHeaderContent}
        </h4>
        <p className="size-90">
          {bannerSubtextContent}
        </p>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', justifyContent: 'center' }}>
          {
            user.loggedOut ?
              <LoggedOutFavoriteButton
                renderWithBanner
                condensed={props.condensed}
                iconButtonSize={props.iconButtonSize}
                iconButtonVariant={props.iconButtonVariant}
              />
              :
              <FavoriteButton
                renderWithBanner
                showCallout={props.showCallout}
                componentName={props.componentName || COMPONENT_NAME}
                condensed={props.condensed}
                iconButtonSize={props.iconButtonSize}
                iconButtonVariant={props.iconButtonVariant}
              />
          }
        </div>
      </div>
    </div>
  );
}
